module.exports = __webpack_public_path__ + "img/service_error.0c42d5c5.png";